import m from "../../geodata/es2015/malaysiaHigh";
window.am4geodata_malaysiaHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/malaysiaHigh.js
// module id = null
// module chunks = 